import { render, staticRenderFns } from "./ConfiguratorTableWood.vue?vue&type=template&id=04a4edbd&scoped=true&"
import script from "./ConfiguratorTableWood.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorTableWood.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorTableWood.vue?vue&type=style&index=0&id=04a4edbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a4edbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
